import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { BiCoinStack } from 'react-icons/bi';
import { IoLockClosedOutline } from 'react-icons/io5';
import { BiLike } from 'react-icons/bi';
import img1 from '../../../../assets/img/Services/OperationalExe/scalable.jpg';

import { IoCloudUploadOutline } from "react-icons/io5";
import { AiOutlineBarChart } from "react-icons/ai";
import { FiServer } from "react-icons/fi";
import { IoMdTrendingUp } from "react-icons/io";

export default function MainSection5() {
  return ( 
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Scalable Infrastructure
            </h1>
            <p className="text-lg text-gray-600">
              Scalable infrastructure enables you to build robust, flexible
              systems that grow with your needs using leading cloud platforms.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCloudUploadOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cloud Platforms</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Leverage AWS, Azure, GCP, and Alibaba Cloud to design resilient
                and scalable systems.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineBarChart className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Dynamic Growth</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Ensure systems can dynamically scale to meet fluctuating
                demands.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FiServer className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  High Availability
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Build infrastructure designed for reliability and minimal
                downtime.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoMdTrendingUp className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cost Efficiency</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Optimize resource utilization to manage costs effectively as you
                scale.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
